module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    },
    on: {
      "after-leave": _vm.doDestroy
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopper),
      expression: "showPopper"
    }],
    staticClass: "el-autocomplete-suggestion",
    class: {
      'is-loading': _vm.parent.loading
    },
    style: ({
      width: _vm.dropdownWidth
    })
  }, [_c('el-scrollbar', {
    attrs: {
      "tag": "ul",
      "wrap-class": "el-autocomplete-suggestion__wrap",
      "view-class": "el-autocomplete-suggestion__list"
    }
  }, [(_vm.parent.loading) ? _c('li', [_c('img', {
    staticClass: "loading-pic",
    attrs: {
      "src": _vm.loadingPic
    }
  })]) : _vm._l((_vm.suggestions), function(item, index) {
    return [(!_vm.parent.customItem) ? _c('li', {
      class: {
        'highlighted': _vm.parent.highlightedIndex === index
      },
      on: {
        "click": function($event) {
          _vm.select(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")]) : _c(_vm.parent.customItem, {
      tag: "component",
      class: {
        'highlighted': _vm.parent.highlightedIndex === index
      },
      attrs: {
        "item": item,
        "index": index
      },
      on: {
        "click": function($event) {
          _vm.select(item)
        }
      }
    })]
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad839418"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls/reference-suggestions.vue
// module id = 1407
// module chunks = 107